import courseAxios from './courseAxios';
import { setCourseStudentToken, clearCourseStudentToken } from '../utils/courseTokenStorage';

export async function registerCourseStudent(formData) {
  const response = await courseAxios.post('/course/auth/register', formData, {
    authMode: 'public',
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function loginCourseStudent(credentials) {
  const response = await courseAxios.post('/course/auth/login', credentials, {
    authMode: 'public',
  });
  return response.data;
}

export async function getCourseStudentMe() {
  const response = await courseAxios.get('/course/auth/me');
  return response.data;
}

export async function logoutCourseStudent() {
  try {
    await courseAxios.post('/course/auth/logout');
  } finally {
    clearCourseStudentToken();
  }
}

export { setCourseStudentToken, clearCourseStudentToken };
